import { config } from './config'

type IntegrationName = 'manual_settings' | 'manual_share_page' | 'gtm'

type SnippetCodeOptions = {
	organizationId: string
	integrationName: IntegrationName
	templateId?: string
}

const cdnEnvPath = config.isTest || config.isDev || config.appURL.includes('labs.') ? 'labs.' : ''

export function getSnippetCode(options: SnippetCodeOptions): string {
	return `
<!-- Start of OpenWidget (www.openwidget.com) code -->
<script>
  window.__ow = window.__ow || {};
  window.__ow.organizationId = "${options.organizationId}";
  window.__ow.integration_name = "${options.integrationName}";
  window.__ow.product_name = "openwidget"; \
  ${typeof options.templateId === 'string' ? `\n  window.__ow.template_id = "${options.templateId}";` : ''}
  ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[OpenWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.${cdnEnvPath}openwidget.com/openwidget.js",t.head.appendChild(n)}};!n.__ow.asyncInit&&e.init(),n.OpenWidget=n.OpenWidget||e}(window,document,[].slice))
</script>
<noscript>You need to <a href="https://www.openwidget.com/enable-javascript" rel="noopener nofollow">enable JavaScript</a> to use the communication tool powered by <a href="https://www.openwidget.com/" rel="noopener nofollow" target="_blank">OpenWidget</a></noscript>
<!-- End of OpenWidget code -->
`
}
